export default function DisabledMessage({ message, campaignName }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center p-6" dir="rtl">
      <div className="text-center max-w-sm">
        <img
          src="https://media.base44.com/images/public/user_69729b1c2410c5c031f1d29a/291b90bb1_.png"
          alt="مغاسل القمر الأبيض"
          className="h-32 w-32 object-contain mx-auto mb-6"
        />
        <div className="text-5xl mb-4">🔒</div>
        <h2 className="text-2xl font-black text-primary mb-3">
          {campaignName || "مغاسل القمر الأبيض"}
        </h2>
        <div className="bg-white rounded-2xl p-6 shadow-lg border border-border">
          <p className="text-muted-foreground leading-relaxed">
            {message || "عجلة العروض متوقفة مؤقتاً. يرجى المراجعة لاحقاً."}
          </p>
        </div>
        <p className="text-xs text-muted-foreground mt-4">
          للاستفسار، تواصل معنا عبر واتساب
        </p>
      </div>
    </div>
  );
}